import * as THREE from 'three'
import Experience from './Experience/Experience'
import PortfolioUI from './UI/PortfolioUI'
import StartButton from './UI/StartButton'


// Initialize Three.js Experience
const experience = new Experience(document.querySelector('canvas.webgl'))

// Initialize Portfolio UI
const portfolioUI = new PortfolioUI()

// Initialize Start Button with portfolio UI reference
const startButton = new StartButton(portfolioUI)

// Wait for resources to load before showing start button
// This assumes the Experience class has an event system or loading manager
document.addEventListener('DOMContentLoaded', () => {
    // Show start button after a short delay
    setTimeout(() => {
        startButton.show()
    }, 1000)
    
    // Setup hero buttons after DOM is loaded
    setTimeout(() => {
        portfolioUI.updateHeroButtons()
    }, 1500)
})

/* NOTE: sectionChanged / scrollProgress への3D側の反応は
   Experience/World/SceneDirector.js が一元管理している */

// Global references for debugging (remove in production)
if (process.env.NODE_ENV === 'development') {
    window.experience = experience
    window.portfolioUI = portfolioUI
    window.startButton = startButton
}